import { Inject, Injectable } from "@angular/core";
import { StorageMap } from "@ngx-pwa/local-storage";
import * as crypto from "crypto-js";
import { LOCAL_STORAGE, StorageService } from "ngx-webstorage-service";
import { Subject } from "rxjs";
import { Store } from "src/app/shared/models/store";
import { OOVenueService } from "./venue-service";

@Injectable({
	providedIn: "root",
})
export class LocalDataStoreService {
	key: string = "bee580cf-33dd-4ca1-9c16-1cb92425c560";

	venue = new Subject<Store>();

	constructor(
		@Inject(LOCAL_STORAGE) private localStorage: StorageService,

		private storage: StorageMap,
		private venueService: OOVenueService
	) {}

	decrypt(data: any): any {
		const bytes = crypto.AES.decrypt(data, this.key);
		return JSON.parse(bytes.toString(crypto.enc.Utf8));
	}

	encrypt(data: any): any {
		return crypto.AES.encrypt(JSON.stringify(data), this.key).toString();
	}

	public async setVenue(venueKey: number) {
		console.log(`setVenue - ${venueKey}`);
		const venue = await this.venueService.assignVenue(venueKey);
		await this.set("venue", venue);
		this.venue.next(venue);
		return venue;
	}

	public getVenue() {
		if (this.venue) {
			return this.venue.asObservable();
		}
		return this.venue.asObservable();
	}

	public async set(key, value) {
		value = this.encrypt(value);
		const data = {
			data: value,
		};
		try {
			await this.storage.set(key, data).toPromise();
		} catch (error) {}

		this.localStorage.set(key, data);
		return await this.storage.get(key).toPromise();
	}

	public getSync(key) {
		return this.decrypt(this.localStorage.get(key).data);
	}

	public async get(key) {
		try {
			const storageData: any = await this.storage.get(key).toPromise();
			// if (key === "venue" && !this.venueService.subscriptionVenue.value?.key !== ) {
			// 	console.log(`lds get ${key}`);
			// 	await this.venueService.assignVenue(this.decrypt(storageData.data));
			// }
			return this.decrypt(storageData.data);
		} catch (error) {
			const localStorageData: any = await this.localStorage.get(key);
			if (localStorageData) {
				try {
					return this.decrypt(localStorageData.data);
				} catch (err) {
					return undefined;
				}
			}
			console.log(`Storage fetch err: ${key}`);
			return undefined;
		}
	}

	public checkSync(key) {
		if (this.localStorage.has(key)) {
			return true;
		}
		return false;
	}

	public async check(key) {
		try {
			let val = await this.storage.has(key).toPromise();
			if (val) {
				return true;
			} else {
				val = this.localStorage.has(key);
				if (val) {
					return true;
				}
			}
			return false;
		} catch (error) {
			const val = this.localStorage.has(key);
			if (val) {
				return val;
			}
			return false;
		}
	}

	public async remove(key) {
		if (await this.storage.has(key).toPromise()) {
			await this.storage.delete(key).toPromise();
		}
		if (this.localStorage.has(key)) {
			this.localStorage.remove(key);
		}
		return;
	}

	public async clearAll() {
		await this.storage.clear().toPromise();
		await this.localStorage.clear();
		return;
	}
}
